/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmEvalsCreateSchedule } from "../../funcs/llmEvalsCreateSchedule.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateEvalScheduleRequest$inboundSchema,
};

export const tool$llmEvalsCreateSchedule: ToolDefinition<typeof args> = {
  name: "llm-evals-create-schedule",
  description: `Create an eval schedule

Schedules an eval run to fire on a cron or interval cadence, with optional webhook notifications of run status.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmEvalsCreateSchedule(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
